import React from 'react';
import imgResolver from '../utils/img-resolver';
import moment from 'moment';
import 'moment-timezone';
import reportTime from '../utils/reportTime';
import checkOverflow from '../utils/checkModalOverflow';

import GoogleMap from '../components/GoogleMap';
import ShiftActivity from '../components/ShiftActivity';

class DetailsShiftModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedTab: 1,
            chatHelperActive: true
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isVisible !== nextProps.isVisible) {
            checkOverflow(nextProps.isVisible);
        }
    }

    toggleSelectedTab(tab) {
        if (tab == 3) {
            this.props.makeMessagesRead();
        }
        this.setState({selectedTab: tab});
    }

    toggleChatHelper() {
        this.setState({chatHelperActive: !this.state.chatHelperActive});
    }

    getContactPersons(contacts) {
        let contacts_data = [];
        contacts.forEach(contact => {
            contacts_data.push(
                <div className="row row-contact">
                    <div className="col cell">
                        <p>{contact.name}</p>
                    </div>
                    <div className="col cell">
                        <p>{contact.phone}</p>
                    </div>
                </div>
            );
        });
        return (
            <div>
                <div className="row">
                    <div className="col cell">
                        <h3>CONTACT PERSONS</h3>
                    </div>
                </div>
                {contacts_data}
            </div>
        );
    }

    getCompanyLogo(logo) {
        let result = '';
        if (logo) {
            result = <div style={{backgroundImage: 'url(' + logo + ')'}} className="logo" />
        }
        return result;
    }

    getCompanyDetails(company) {
        let companyDetails;
        if (!!Object.keys(company).length) {
            const website_url = (company.website.toLowerCase().startsWith('http') ? '' : 'http://') + company.website;
            companyDetails = (
                <div className="tab-section tab-section-company">
                    <div className="modal-content clearfix">

                        <div className="company-col company-left-col">

                            <div className="company-wrapper">
                                {this.getCompanyLogo(company.logo)}
                                <div className={"company " + (company.logo ? '' : 'no-logo')}>
                                    <h2 className="company-title">{company.name}</h2>
                                    <p className="location">{company.city + ', ' + company.country}</p>
                                </div>
                            </div>

                            <div className="company-description">
                                <p>
                                    {company.description}
                                </p>
                            </div>
                        </div>

                        <div className="company-right-col">

                            <div className="col cell">
                                <h3>CONTACT</h3>
                                <p>{company.email}</p>
                            </div>

                            <div className="col cell">
                                <h3>TEL</h3>
                                <p>{company.phone}</p>
                            </div>

                            <div className="col cell">
                                <h3>WEBSITE</h3>
                                <p><a href={website_url} target="_blank" className="button-transparent">{company.website}</a></p>
                            </div>
                        </div>


                    </div>
                </div>
            );
        }
        return companyDetails;
    }

    detailsContent(shift) {
        let google = '';
        const address = shift.formatted_address || (shift.street ? shift.street + ', ' : '') + shift.city + (shift.zip ? ' ' + shift.zip :  '');
        const start_time = moment(shift.start_time).tz(shift.company.timezone);
        const end_time = moment(shift.end_time).tz(shift.company.timezone);
        const time = reportTime(start_time, end_time);
        const price = shift.hiring && shift.hiring.price ? shift.hiring.price : shift.rate;

        if (process.env.BROWSER) {
            google = <GoogleMap center={{lat: shift.lat, lng: shift.lng}} zoom={15} scrollwheel={false} />;
        }

        return (
            <div>
            {google}
                <div className="modal-content">

                    <div className="row">
                        <div className="col cell">

                            <h3>VENUE</h3>
                            <p>{shift.venue}</p>

                        </div>

                        <div className="col cell">

                            <h3>ADDRESS</h3>
                            <p>{address}</p>

                        </div>
                        {shift.dresscode ?
                        <div className="col cell">

                            <h3>DRESSCODE</h3>
                            <p>{shift.dresscode}</p>

                        </div>: ''}
                    </div>

                    <div className="row">
                        <div className="col cell">
                            <h3>DATE</h3>
                            <p>{start_time.format('Do of MMMM')}</p>
                        </div>

                        <div className="col cell">
                            <h3>TIME</h3>
                            <p>{time}</p>
                        </div>

                        <div className="col cell rate">
                            <div className="hourly-rate">
                                <div className="details-overlay">
                                    <h3>PAYMENT METHOD</h3>
                                    <p>{shift.payment_info}</p>

                                    <h3>PAYMENT DELIVERY INFO</h3>
                                    <p>{shift.payment_delivery_info}</p>

                                    <h3>CONTACT</h3>
                                    <p>{shift.company.email}</p>
                                    <p>{shift.company.phone}</p>
                                </div>
                            </div>
                            <div className="text">
                                <div className="rate">{DJ_CONST.LOCALE_CONF.currency}{price} / h</div>
                                <div className="total">Total: {DJ_CONST.LOCALE_CONF.currency}{shift.total_pay}</div>
                            </div>
                        </div>
                    </div>

                    {shift.description ? <div className="row">
                        <div className="cell description">
                            <h3>DESCRIPTION</h3>
                            <p dangerouslySetInnerHTML={{__html: shift.description.replace(/(\r\n|\n|\r)/gm, '<br>')}}></p>
                        </div>
                    </div>: ''}

                    {this.getContactPersons(shift.contacts)}

                </div>

                {this.getCompanyDetails(shift.company)}
            </div>
        );
    }

    activityContent() {
        return (
            <div>
                <ShiftActivity isActive={true} />
            </div>
        );
    }

    sendMessage() {
        const data = {};
        let messageBox = this.refs.messageBox.getDOMNode();
        data.message = messageBox.value.replace(/<\/?[^>]+(>|$)/g, "");
        data.user_id = this.props.user.profile.id;
        data.shift_id = this.props.shift.id;
        data.sender = this.props.user.profile.id;
        if (data.message) {
            this.props.sendMessage(data);
            messageBox.value = '';
        }
    }

    getProfilePicture(profile_picture) {
        if (profile_picture) {
            return <div className="profile-picture" style={{backgroundImage: 'url('+profile_picture+')'}}></div>;
        } else {
            return <div className="profile-picture" style={{backgroundImage:'url(' + require('../styles/images/team_member.png') + ')'}}></div>

        }
    }

    getMessages(messages, shift) {
        let results = [];
        messages.forEach(message => {
            const isYou = this.props.user.profile.first_name + ' ' + this.props.user.profile.last_name == message.user_name ? ' (You)' : '';
            const msgTimestamp = moment(message.date).tz(shift.company.timezone);
            results.push(
                <div className="message">
                    {this.getProfilePicture(message.profile_picture)}
                    <div className="message-content">
                        <div className="name">{message.user_name + isYou}</div>
                        <div className="content">{message.message}</div>

                        <div className="message-info">
                            <div className="date">{msgTimestamp.format('D. MMM YYYY')}</div>
                            <div className="time">{msgTimestamp.format('h:mm A')}</div>
                        </div>
                    </div>
                </div>
            );
        });
        return results;
    }

    getSendMessageButton() {
        let button = <button onClick={this.sendMessage.bind(this)} className="btn btn-green">SEND A MESSAGE</button>;
        const loading = this.props.isLoading;
        if (loading) {
            button = <button className="btn btn-green"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></button>;
        }
        return button;
    }

    shouldShowChat(shift) {

        if ([DJ_CONST.SHIFT_STATUSES.CANCELLED, DJ_CONST.SHIFT_STATUSES.ENDED, DJ_CONST.SHIFT_STATUSES.FINISHED].indexOf(shift.status) >= 0) {
            return false;
        } else if (!shift.hiring) {
            return false;
        } else if ([DJ_CONST.HIRING_STATUSES.HIRED].indexOf(shift.hiring.status) >= 0) {
            return true
        } else if ([DJ_CONST.HIRING_STATUSES.CANCELLED, DJ_CONST.HIRING_STATUSES.CANCELLED_BY_US].indexOf(shift.hiring.status) >= 0) {
            return false;
        }

        return shift.chat;
    }

    chatContent(shift, messages) {
        let chatWriting;
        if (this.shouldShowChat(shift)) {
            chatWriting = (
                <div className="tab-section settings-form">
                    <div className="modal-content">
                        <h3 className="reply">WRITE A MESSAGE</h3>
                        <div className="textarea">
                            <textarea ref="messageBox" className="form-control">
                            </textarea>
                            <div className={'helper-wrapper ' + (this.state.chatHelperActive ? 'active' : '')}>
                                <div className="info">
                                    <p className="question">Need more information?</p>
                                    <p className="answer"> Here you can send a message to the employer.</p>
                                    <div className="close" onClick={this.toggleChatHelper.bind(this)}>×</div>
                                </div>
                            </div>
                        </div>
                        {this.getSendMessageButton()}
                        <p className={"message-sent " + (this.props.messageSent ? 'done' : '')}>Message sent!</p>
                    </div>
                </div>
            )
        }

        return (
            <div>
                <div className="modal-content chat">
                    <div className="messenger-wrapper">
                        {this.getMessages(messages, shift)}
                    </div>
                </div>
                {chatWriting}
            </div>
        );
    }

    getApplyButton(applied) {
        //PS! Using this in two places (responsive and non-responsive)

        if (applied) {
            return '';
        }

        if (this.props.user.can_apply) {
            if (this.props.isLoading) {
                return <button className="btn btn-small btn-green"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></button>;
            } else {
                const created = this.props.hiringCreated || false;
                const buttonText = created ? 'Done!' : 'Apply';
                return <button className={"btn btn-small btn-green btn-apply " + (created ? "created" : "")} onClick={this.props.applyForShift}>{buttonText}</button>;
            }
        } else {
            return <button className="btn btn-small btn-gray btn-apply btn-tooltip btn-tooltip-bottom" disabled>Apply<div className="btn-tooltip-content">User not active</div></button>;
        }
    }

    cancelHiring() {
        this.setState({selectedTab: 1});
        this.props.cancelHiring();
    }

    getCancelButton(status) {
        //PS! Using this in two places (responsive and non-responsive)
        let button = '';
        if (status == 'APPLIED' || status === true) {
            button = <button onClick={this.cancelHiring.bind(this)} className="btn-transparent">UNAPPLY</button>;
        }

        return button;
    }

    getChatNavButton(shift) {
        const messages = this.props.messages;
        let chatNavButton;
        if (messages.length > 0 || this.shouldShowChat(shift)) {
            chatNavButton = <li onClick={this.toggleSelectedTab.bind(this, 3)} className={(this.state.selectedTab === 3 ? 'active' : '')}>Chat</li>;
        }
        return chatNavButton;
    }

    getAppliedHeader(shift) {
        const created = this.props.hiringCreated;
        const ended = moment(shift.end_time) < moment();
        let labelText = null;
        if (shift.status === DJ_CONST.SHIFT_STATUSES.CANCELLED || (shift.hiring && [DJ_CONST.HIRING_STATUSES.CANCELLED, DJ_CONST.HIRING_STATUSES.CANCELLED_BY_US].indexOf(shift.hiring.status) >= 0)) {
            labelText = 'CANCELLED';
        } else if (ended) {
            labelText = shift.status === DJ_CONST.SHIFT_STATUSES.FINISHED ? 'COMPLETED' : 'TO BE FINISHED';
        } else if (shift.hiring && shift.hiring.status == DJ_CONST.HIRING_STATUSES.HIRED) {
            labelText = 'APPROVED';
        } else if (shift.hiring || this.props.hiringCreated) {
            labelText = 'APPLIED';
        }
        const statusesClass = 'statuses' + (shift.hiring && shift.hiring.status == DJ_CONST.HIRING_STATUSES.HIRED && shift.status === DJ_CONST.SHIFT_STATUSES.PUBLISHED ? ' approved-tooltip' : '');
        let label;

        if (labelText) {
            label = <li className="approved">{labelText}</li>;
        }

        return (
            <header className={"modal-tabs " + (shift.hiring || created ? 'open' : '')}>
                <ul className={"menu " + (created ? ' open' : '')}>
                    <li onClick={this.toggleSelectedTab.bind(this, 1)} className={(this.state.selectedTab === 1 ? 'active' : '')}>Details</li>
                    {/*<li onClick={this.toggleSelectedTab.bind(this, 2)} className={(this.state.selectedTab === 2 ? 'active' : '')}>Activity</li>*/}
                    {this.getChatNavButton(shift)}
                </ul>

                <ul className={statusesClass}>
                    {label}
                    <li className="cancel">
                        {this.getCancelButton(labelText)}
                    </li>
                    <div className="cancel-tooltip">
                        You are approved and cannot cancel this job anymore. If you still want to cancel, then contact the company
                    </div>
                </ul>
            </header>
        );
    }

    render() {
        let classes = "modal-overlay details-shift-modal-overlay";
        const shift = this.props.shift;
        const messages = this.props.messages;
        if (this.props.isVisible) classes += " active";

        if (!shift) {
            return <div></div>;
        }

        let content = '';
        switch (this.state.selectedTab) {

            case 1:
                content = this.detailsContent(shift);
                break;

            case 2:
                content = this.activityContent(shift);
                break;

            case 3:
                content = this.chatContent(shift, messages);
                break;
        }

        return (
            <div ref="modal" onClick={this.toggleModal.bind(this)} className={classes}>
                <div onClick={this.modalClick.bind(this)} className="modal whitebox">
                    <header className="modal-header">
                        <h1>{shift.position.name} - {shift.venue}</h1>
                        {this.getApplyButton(shift.hiring != null)}
                        <button className="close" onClick={this.toggleModal.bind(this)}>
                            <span>&times;</span>
                        </button>
                    </header>
                    {this.getAppliedHeader(shift)}
                    {content}
                    <div className="tab-section responsive-buttons">
                        {this.getApplyButton(shift.hiring != null)}
                        {this.getCancelButton(shift.hiring && shift.hiring.status == DJ_CONST.HIRING_STATUSES.PENDING)}
                    </div>
                </div>
            </div>
        );
    }

    modalClick(evt) {
        evt.stopPropagation();
    }

    toggleModal() {
        this.setState({selectedTab: 1});
        this.props.toggleModal();
    }
}

export default DetailsShiftModal;



/** WEBPACK FOOTER **
 ** ./app/src/components/DetailsShiftModal.js
 **/